export enum SmsMessageType {
  CONFIRMATION = 'confirmation',
  INVITATION = 'invitation'
}
